<slotcom-wallet
  class="wallet-container"
  [type]="'Gems'"
  [showBuyButton]="true"
  (click)="openGemsShop()"></slotcom-wallet>
<div class="dark-background">
  <div class="img-container">
    <div
      class="img-logo"
      theming
      themingGroup="dailychallenge"
      themingAsset="logo"
      [themingOverride]="event?.assets"></div>
    <div class="img-background"></div>
  </div>

  <div class="text-container">
    <div class="streak">
      <div class="lost-streak">
        <div class="img"></div>
        <div class="circle"></div>
        <span>0</span>
      </div>

      <div class="arrow">
        <div class="gem"></div>
      </div>

      <div class="keep-streak">
        <div class="img"></div>
        <div class="circle"></div>
        <span>{{ keepStreakModalData.properties.streak }}</span>
      </div>
    </div>

    <div>
      <slotcom-p
        class="text-title"
        [bold]="true"
        [text]="'home.streak.keep-streak.title' | translate | uppercase"
        [shadowBorder]="true"></slotcom-p>

      <slotcom-p
        class="text-confirmation"
        [bold]="true"
        [text]="'home.streak.keep-streak.subtitle' | translate"
        [shadowBorder]="true"></slotcom-p>
    </div>
  </div>

  <div class="footer">
    <slotcom-button
      class="c-button--pink"
      data-testid="slotcom-dailyChallenge-keepStreak-button"
      [isLoading]="loading()"
      (safeClick)="keepStreak()"
      audioType="payment">
      <span class="gem-icon"></span>
      <span class="label">{{ keepStreakModalData.properties.price }}&nbsp;</span>
    </slotcom-button>

    <span
      class="lose-streak"
      (click)="closeModal(true)"
      >{{ 'home.streak.keep-streak.lose-streak' | translate }}</span
    >
  </div>
</div>
